module.exports = __webpack_public_path__ + "img/screenshot_round.639c51b2.jpg";